export const camelToPascalConverter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
//# sourceMappingURL=camelToPascal.js.map